import { Navigate, Outlet } from "react-router-dom";
import { getUser } from "../Services/authService";

const PrivateRoute = ({ allowedRoles }: { allowedRoles: string[] }) => {
  const user = getUser();
  console.log("Retrieved User:", user); // Debugging line

  if (!user) return <Navigate to="/login" replace />;
  
  if (!user.role || !user.role.name) {
    console.error("User role is missing!", user);
    return <Navigate to="/unauthorized" replace />;
  }

  const userRole = user.role.name.trim().toLowerCase();
  const allowedRolesLower = allowedRoles.map((role) => role.toLowerCase());

  console.log(`Checking access for role: ${userRole} (Allowed: ${allowedRolesLower})`);

  if (!allowedRolesLower.includes(userRole)) {
    console.error(`Unauthorized Role: ${userRole}`);
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
